import React, { useState, useEffect } from 'react';
import Slider from "components/Slider";
import ProductService from 'services/Product/';
import Loader from "components/Loader/index";
import style from './style.scss';//NOSONAR
import { getLinkCategory } from 'utils/index'

const SearchCategory = () => {
    let categories = [];
    const [isLoaded, setIsLoaded] = useState(false);
    const [infoCategories, setInfoCategories] = useState(null);
    
    useEffect(() => {
        ProductService.getCategories().then(results => {
            if (!results || !results[0]) return false;
            
            categories = results.map(category => {
                return {
                    name: category.name,
                    url: getLinkCategory(category.url),
                    icon: getLinkCategory(category.url).replace('/', 'jumbo-icon-category-')
                }
            });
            setInfoCategories(categories);
            setIsLoaded(true);
        })

    }, []);

    return (
        <section className={'search-department-wrapper'}>
            <header className={'search-department-header'}>
                <h2 className={'search-department-title'}>Busca por Categoría</h2>
            </header>
            {isLoaded && <div className={'search-department-content'}>
                <Slider arrows={true} className={'search-department-list'}>
                    {infoCategories.map((category, i) => <a href={category.url} className={'search-department-item'} key={i}>
                        <div className={'search-department-icon'}>
                            <i className={category.icon}></i>
                        </div>
                        <div className={'search-department-name'}>{category.name}</div>
                    </a>)}
                </Slider>
            </div>}
            {!isLoaded && <Loader />}
        </section>
    )
}

export default SearchCategory;
